export const KEY_LOCAL_STORAGE_DONT_SHOW_tOUR_BLOCK = 'tour-block-dont-show';
export const KEY_LOCAL_STORAGE_DONT_SHOW_TOOLTIP_TRAIN = 'tooltip-train-dont--show';
export const KEY_LOCAL_STORAGE_FLAG_STEP_ONE = 'TOUR_STEP_ONE';
export const KEY_LOCAL_STORAGE_DONT_VISIBLE_WELCOME_MODAL = 'DONT_VISIBLE_WELCOME_MODAL';


export const KEY_LOCAL_STORAGE_SUCCESS_TOUR_STEP_1 = 'SUCCESS_TOUR_STEP_1';
export const KEY_LOCAL_STORAGE_SUCCESS_TOUR_STEP_2 = 'SUCCESS_TOUR_STEP_2';
export const KEY_LOCAL_STORAGE_SUCCESS_TOUR_STEP_3 = 'SUCCESS_TOUR_STEP_3';
export const KEY_LOCAL_STORAGE_SUCCESS_TOUR_STEP_4 = 'SUCCESS_TOUR_STEP_4';
export const KEY_LOCAL_STORAGE_SUCCESS_TOUR_STEP_5 = 'SUCCESS_TOUR_STEP_5';
export const KEY_LOCAL_STORAGE_SUCCESS_TOUR_STEP_6 = 'SUCCESS_TOUR_STEP_6';


export const STEPS = {
    ONE: 'ONE_STEP_CALENDAR',
    TWO: 'ONE_STEP_VIDEO_HUB',
    THREE: 'ONE_STEP_VIDEO_PAGE',
    THREE_NEXT_TWO: 'TWO_STEP_VIDEO_PAGE',
    FOUR: 'ONE_STEP_INTEGRATIONS',
    FIVE: 'ONE_STEP_COPILOT',
    SIX: 'ONE_STEP_AGENTS',
    SEVEN: 'ONE_STEP_FINAL',
}

export const countSuccessSteps = () => {
    let count = 0;
    for (let i = 1; i <= 6; i++) {
        if (localStorage.getItem(`SUCCESS_TOUR_STEP_${i}`)) {
            count += 1;
        }
    }
    return count;
}

export const getStepsLocal = () => {
    let obj = {};
    for (let i = 1; i <= 6; i++) {
        obj[`KEY_LOCAL_STORAGE_SUCCESS_TOUR_STEP_${i}`] = Boolean(localStorage.getItem(`SUCCESS_TOUR_STEP_${i}`))
    }
    return obj;
}